import type { CdcUserAttributes } from "models/cdcUser";
import { EuropeanCountry } from "pages/commons/constants";
import { useMemo } from "react";
import { getDataFromLocalstorageByKey } from "service/utils/get-data-localstorage";
import { type RequestState, useAuthenticatedRequest } from "./request";

export interface IHazardClass {
  messageType: string;
  message: string;
  profile: string;
  color?: string;
}

interface HazardClassResult {
  results: IHazardClass[];
}

function getProfileFromUserCountry(userCountry: string | undefined): string {
  if (!userCountry) {
    return ""; // Return all profiles if no country is set
  }

  // Check if user is from Great Britain
  if (userCountry === "GB") {
    return "CLP_GB";
  }

  // Check if user is from an EU country
  const isEUCountry = EuropeanCountry.some(
    (country) => country.code === userCountry,
  );
  if (isEUCountry) {
    return "CLP_EU";
  }

  // For all other countries, return all profiles
  return "";
}

export function useHazardClasses(
  sapNumber: string | undefined,
): RequestState<HazardClassResult> {
  const cdcUser: CdcUserAttributes = getDataFromLocalstorageByKey("cdcUser");

  const profile = useMemo(() => {
    return getProfileFromUserCountry(cdcUser?.country);
  }, [cdcUser?.country]);

  if (sapNumber) {
    const url = profile
      ? `/v0/clp?productNumber=${sapNumber}&profile=${profile}`
      : `/v0/clp?productNumber=${sapNumber}`;

    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useAuthenticatedRequest(url);
  }

  return [
    {
      results: [],
    },
    undefined,
    false,
  ];
}
